module.exports = __webpack_public_path__ + "img/201709-2-1024x768.bf0d4e38.jpeg";